var map = {
	"./avatar-fleur-base-full.png": 94294,
	"./avatar-fleur-dino-full.png": 46955,
	"./avatar-fleur-fall-full.png": 70254,
	"./avatar-fleur-smoothie-full.png": 45715,
	"./avatar-fleur-space-full.png": 24145,
	"./avatar-fleur-spring-full.png": 23470,
	"./avatar-fleur-summer-full.png": 59222,
	"./avatar-fleur-winter-full.png": 23558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18031;